import React from 'react'
import { Flex } from '@jisr-hr/design-system'
import JisrLoader from 'components/global/JisrLoader'
import { useDispatch } from 'react-redux'
import {
  assetClearRequestsCreate,
  assetsRequestCreate,
} from 'redux/requests/assetRequests/actionCreators'
import { useFormState } from 'react-final-form'
import { AssetDetails, Reason, Profile } from '../../components/forms'
import { useRequest } from '../../RequestProvider'

const AssetRequest = () => {
  const dispatch = useDispatch()
  const {
    values: { request_type },
  } = useFormState()
  const {
    setOnSubmit,
    setInitialValues,
    vars: { id, employee },
    drawerToggle,
    actionCallback,
  } = useRequest()

  const closeDrawer = () => {
    drawerToggle()
    if (actionCallback) {
      actionCallback()
    }
  }

  const onSubmit = (val) => {
    const currRequestType = val?.request_type || request_type
    const dataAsset = {
      ...val,
      asset_request_types_attributes: val.asset_request_types_attributes?.map((asset_type_id) => ({
        asset_type_id,
      })),
    }
    delete dataAsset.request_type
    // const dataAssetClear = {
    //   request_type: val?.request_type,
    //   asset_ids: val.asset_request_types_attributes?.map(asset_type_id => asset_type_id),
    // };
    const dataAssetClear = {
      ...val,
      asset_ids: val.asset_request_types_attributes?.map((asset_type_id) => asset_type_id),
    }
    delete dataAssetClear.asset_request_types_attributes
    delete dataAssetClear.request_type
    if (currRequestType === 2) {
      return dispatch(assetClearRequestsCreate(id, dataAssetClear)).then(() => closeDrawer())
    }
    return dispatch(assetsRequestCreate(id, dataAsset)).then(() => closeDrawer())
  }
  React.useEffect(() => {
    setOnSubmit(onSubmit)
    setInitialValues({
      request_type: 1,
    })

    return () => {
      setOnSubmit(() => {})
      setInitialValues({})
    }
  }, [])

  return (
    <Flex
      flexCol
      style={{ gap: '16px' }}
    >
      {false && <JisrLoader absolute />}
      <Profile employee={employee} />
      <AssetDetails />

      <Reason />
    </Flex>
  )
}

export default AssetRequest
